import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled/box';
import Skeleton from '@atlaskit/skeleton';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	subheader: {
		display: 'flex',
		height: '2.5rem',
		alignItems: 'center',
		gap: token('space.150'),
		paddingBlockEnd: token('space.200'),
		paddingInlineStart: token('space.300'),
		paddingInlineEnd: token('space.300'),
	},
	icon: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: '1.5rem',
		height: '1.5rem',
	},
});

export type PanelSubheaderSkeletonProps = {
	shouldShowIcon?: boolean;
};

export function PanelSubheaderSkeleton({
	shouldShowIcon,
}: PanelSubheaderSkeletonProps): JSX.Element {
	return (
		<Box xcss={styles.subheader}>
			{shouldShowIcon && (
				<Box xcss={styles.icon}>
					<Skeleton width="1.5rem" height="1.5rem" borderRadius={token('radius.tile')} />
				</Box>
			)}
			<Skeleton width={120} height="0.9375rem" borderRadius={token('radius.full')} />
		</Box>
	);
}
